const teamChat = (state = {
    activeConversations: [],
    newConversationActive: false,
    newConversationInvitees: [],
    widget: true,
    widgetOpen: false
}, action) => {
    switch (action.type) {
        case 'TEAMCHAT_CONFIG_FETCH_SUCCEEDED':
            if (!action.payload.config) {
                return state;
            }

            return Object.assign({}, state, action.payload.config);

        case 'TEAMCHAT_ACTIVATE_CONVERSATION_REQUESTED':
            return Object.assign({}, state, {
                activeConversations: state.widget ? [...state.activeConversations.filter(conversationId => conversationId && conversationId.split('/')[0] !== action.payload.conversationId), action.payload.conversationId] : [action.payload.conversationId]
            });

        case 'TEAMCHAT_DEACTIVATE_CONVERSATION_REQUESTED':
            return Object.assign({}, state, {
                activeConversations: state.activeConversations.filter(conversationId => conversationId && conversationId.split('/')[0] !== action.payload.conversationId)
            });

        case 'TEAMCHAT_DEACTIVATE_ALL_CONVERSATIONS_REQUESTED':
            return Object.assign({}, state, {
                activeConversations: []
            });

        case 'TEAMCHAT_SHOW_NEW_CONVERSATION_REQUESTED':
            return Object.assign({}, state, {
                newConversationActive: true,
                newConversationInvitees: action.payload.invitees,
                activeConversations: state.widget ? state.activeConversations : []
            });

        case 'TEAMCHAT_HIDE_NEW_CONVERSATION_REQUESTED':
            return Object.assign({}, state, {
                newConversationActive: false
            });

        case 'TEAMCHAT_WIDGET_ENABLE_REQUESTED':
            return Object.assign({}, state, {
                widget: true
            });

        case 'TEAMCHAT_WIDGET_DISABLE_REQUESTED':
            return Object.assign({}, state, {
                widget: false,
                widgetOpen: false
            });

        case 'TEAMCHAT_WIDGET_OPEN_REQUESTED':
            return Object.assign({}, state, {
                widgetOpen: true
            });

        case 'TEAMCHAT_WIDGET_CLOSE_REQUESTED':
            return Object.assign({}, state, {
                widgetOpen: false
            });

        case 'DISCUSSION_LEAVE_REQUESTED':
        case 'DISCUSSION_KICK_SOCKET':
        case 'DISCUSSION_REMOVE_SUCCEEDED':
        case 'DISCUSSION_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.activeConversations.filter(conversationId => conversationId && conversationId.split('/')[0] !== action.payload.discussionId)
            });

        case 'DISCUSSION_LEAVE_SOCKET':
            if (!action.payload.self) {
                return state;
            }

            return Object.assign({}, state, {
                items: state.activeConversations.filter(conversationId => conversationId && conversationId.split('/')[0] !== action.payload.discussionId)
            });

        default:
            return state;
    }
}

export default teamChat;
